export default __webpack_public_path__ + "static/media/m1.3d1a888d.jpg";